import camelize from 'camelcase-keys-deep';

export default class LotState {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }
}
